import * as api from "api"
import { getSeoKey } from "api"
import slugify from "common/bit/utils/slugify"
import SeoMetaData, { SeoMetadataWithImage } from "common/SeoMetaData"
import SingleServiceCenterPage from "components/mapPages/singleServiceCenter/SingleServiceCenterPage"

import { GetStaticPaths, GetStaticProps } from "next"

type ServiceCenterStaticProps = {
  serviceCenterId: string
  serviceCenterSlug: string
}
export const getStaticPaths: GetStaticPaths<
  ServiceCenterStaticProps
> = async () => {
  const { data } = await api.getServiceCenter(null, null)
  const paths =
    data.body?.map((serviceCenter) => ({
      params: {
        serviceCenterId: serviceCenter.id.toString(),
        serviceCenterSlug: slugify(serviceCenter.name),
      },
    })) || []
  return { paths, fallback: "blocking" }
}

type ServiceCenterProps = {
  serviceCenter: api.SingleServiceCenter
  seo: SeoMetadataWithImage
}

export const getStaticProps: GetStaticProps<
  ServiceCenterProps,
  ServiceCenterStaticProps
> = async ({ params }) => {
  const data = await api
    .getServiceCenterId(params.serviceCenterId)
    .then(api.extractData)
  const slugifyName = slugify(data.body.name)

  if (slugifyName !== params.serviceCenterSlug) {
    return {
      notFound: true,
    }
  }
  const seoData = await getSeoKey("serviceCenterTemplate")

  const seo = {
    title:
      seoData.data.body?.title
        .replace("{name}", data.body.name)
        .replace("{city}", data.body.city) || "",
    description:
      seoData.data.body?.description
        .replace("{name}", data.body.name)
        .replace("{city}", data.body.city) || "",
    keywords: seoData.data.body?.keywords || "",
  }

  return { props: { serviceCenter: data?.body, seo: seo }, revalidate: 60 }
}

const ServiceCenter = ({ serviceCenter, seo }: ServiceCenterProps) => {
  return (
    <>
      <SeoMetaData data={seo} />

      <SingleServiceCenterPage centerData={serviceCenter} />
    </>
  )
}

export default ServiceCenter
